import event from '../../event/event';

export default event('/compliance/control-variance-list/show');
